import { useMultiStyleConfig } from '../../../../../utils/use-style-config';
import { Box, GridItem } from '../../../../internal';
import { jsx as _jsx } from "react/jsx-runtime";
export var Indicator = _ref => {
  var {
    isActive,
    isDone
  } = _ref;
  var styles = useMultiStyleConfig('TrackerStep', {
    isActive,
    isDone
  });
  return /*#__PURE__*/_jsx(GridItem, {
    __css: styles['stepIndicatorContainer'],
    children: /*#__PURE__*/_jsx(Box, {
      __css: styles['stepIndicator']
    })
  });
};
Indicator.displayName = 'TrackerStep.Indicator';
//# sourceMappingURL=Indicator.js.map